import { useEffect } from "react";
import FilterValueProps from "types/FilterValueProps";

interface useFilterOptionsProps{
    options: Array<FilterValueProps>
    setFilteredOptions: Function
    filterText: string
}

const useFilterOptions = (props: useFilterOptionsProps) => {
useEffect(() => {
    const newFilteredOptions = props.options.filter((option) =>
      option.label.toLowerCase().includes(props.filterText.toLowerCase())
    );
    props.setFilteredOptions(newFilteredOptions);
  }, [props.filterText, props.options]);
}


export default useFilterOptions 